import ConversationReadingPaneViewState from './schema/ConversationReadingPaneViewState';
import ItemReadingPaneViewState from './schema/ItemReadingPaneViewState';
import ReadingPaneStore from './schema/ReadingPaneStore';
import { ObservableMap } from 'mobx';
import { isFeatureEnabled } from 'owa-feature-flags';
import conversationCache from 'owa-mail-store/lib/store/conversationCache';
import { createStore } from 'satcheljs';

const initialReadingPaneStore: ReadingPaneStore = {
    conversationReadingPaneViewState: null,
    loadedItemReadingPaneViewStates: new ObservableMap<string, ItemReadingPaneViewState>({}),
    loadedConversationReadingPaneViewStates: new ObservableMap<
        string,
        ConversationReadingPaneViewState
    >({}),
    itemReadingPaneViewState: null,
    itemPreviewPaneViewState: null,
    itemPrintPaneViewState: null,
    deeplinkId: null,
    shouldShowMobileUpsellEmptyState: false,
};

export let getStore = createStore<ReadingPaneStore>('readingpane', initialReadingPaneStore);
const store = getStore();

// Register the reading pane conversation with the conversation cache
conversationCache.registerReference(() =>
    isFeatureEnabled('rp-persistedReadingPaneTabs')
        ? [...store.loadedConversationReadingPaneViewStates.keys()]
        : store.conversationReadingPaneViewState?.conversationId?.Id
);

export default store;
